import { useEffect } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export default function GetInformation(props) {
  const { user, logout } = useAuth0();

  // propsを受け取る
  const { setUserName, setUserEmail, setCookie, removeCookie, setVersionId } =
    props;

  const baseURL = process.env.REACT_APP_BASEURL; // パス指定

  // ユーザー情報取得
  async function getUserInfo() {
    try {
      console.log("getUserInfo!", user.email);

      const queries = { useremail: user.email };
      const res = await axios.get(`${baseURL}/userinfo`, { params: queries });
      const username = res.data.user_name;
      const useremail = res.data.email;
      const isadmin = res.data.is_admin_user;
      console.log("userEmail:", useremail, "userName", username); // 存在しないユーザーはログアウト
      if (typeof useremail === "undefined") {
        removeCookie("isAdmin");
        console.log("◆◆◆ Error ◆◆◆ 存在しないユーザーはログアウトします");
        logout({ returnTo: window.location.origin });
      }
      setUserName(username);
      setUserEmail(useremail);
      setCookie("isAdmin", isadmin);
    } catch (error) {
      alert("ユーザー情報の取得に失敗しました。");
      const { status, statusText } = error.response;
      console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
    }
  }

  // マウント時に1回だけ実行
  useEffect(() => {
    getUserInfo();
    setVersionId(process.env.REACT_APP_SYSTEM_VERSION);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
